import { Check, Monitor, Moon, Sun } from 'lucide-react';
import { useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { Button } from '@/components/ui/button';
import { temaDinle, temaTercihi, temaTercihiniAyarla, type TemaTercihi } from '@/lib/theme';

const SECENEKLER: ReadonlyArray<{ deger: TemaTercihi; ad: string; Simge: typeof Sun }> = [
  { deger: 'light', ad: 'Açık', Simge: Sun },
  { deger: 'dark', ad: 'Koyu', Simge: Moon },
  { deger: 'system', ad: 'Sistem', Simge: Monitor },
];

/** Üst çubuktaki tema düğmesi: yer kaplamasın diye simge, seçim açılır listede. */
export function TemaSecici() {
  const tercih = useSyncExternalStore(temaDinle, temaTercihi);
  const [acik, setAcik] = useState(false);
  const kutu = useRef<HTMLDivElement>(null);
  const secili = SECENEKLER.find((s) => s.deger === tercih) ?? SECENEKLER[2]!;

  useEffect(() => {
    if (!acik) return;
    const disari = (e: MouseEvent) => {
      if (kutu.current && !kutu.current.contains(e.target as Node)) setAcik(false);
    };
    const tus = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setAcik(false);
    };
    document.addEventListener('mousedown', disari);
    document.addEventListener('keydown', tus);
    return () => {
      document.removeEventListener('mousedown', disari);
      document.removeEventListener('keydown', tus);
    };
  }, [acik]);

  return (
    <div className="relative" ref={kutu}>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setAcik((v) => !v)}
        aria-expanded={acik}
        aria-haspopup="menu"
        aria-label={`Tema: ${secili.ad}`}
        title={`Tema: ${secili.ad}`}
        data-testid="tema-secici"
      >
        <secili.Simge aria-hidden="true" />
      </Button>

      {acik && (
        <div
          role="menu"
          aria-label="Tema"
          className="menu-acilis absolute right-0 z-50 mt-2 w-36 rounded-[var(--radius)] border border-border bg-bg-elevated p-1 shadow-[var(--shadow-md)]"
        >
          {SECENEKLER.map(({ deger, ad, Simge }) => (
            <button
              key={deger}
              type="button"
              role="menuitemradio"
              aria-checked={deger === tercih}
              title={deger === 'system' ? 'Cihazın ayarını izler' : undefined}
              onClick={() => {
                temaTercihiniAyarla(deger);
                setAcik(false);
              }}
              className="flex w-full items-center gap-2 rounded-[var(--radius-sm)] px-3 py-2 text-left text-sm text-fg-muted transition-colors hover:bg-accent-soft hover:text-fg"
            >
              <Simge className="size-4" aria-hidden="true" />
              <span className="flex-1">{ad}</span>
              {deger === tercih && <Check className="size-4 text-accent" aria-hidden="true" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
